import { TableSettings } from '../../components/MyGridRedux/types';
import { State } from '@progress/kendo-data-query';
import { gridSettingsProps } from '../../components/MyGridCore/types';
import { getInitialDataState } from './slice';
import { FilterDescriptor } from '@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface';
import { multiselectOperator } from '../../components/MultiSelectFilterCell/MultiSelectFilterCell';
import { inOperator } from '../../components/IdFilterCell/IdFilterCell';

const operatorToName = (operator: Function): string | undefined => {
  const operatorStr = operator.toString();
  let name;
  if (operatorStr == multiselectOperator.toString()) {
    name = 'custom_multiselect';
  } else if (operatorStr == inOperator.toString()) {
    name = 'custom_in';
  } else {
    throw new Error('Operator not valid');
  }
  return name;
};

const nameToOperator = (name: string): Function | string => {
  switch (name) {
    case 'custom_multiselect':
      return multiselectOperator;
    case 'custom_in':
      return inOperator;
    default:
      return name;
  }
};

export const preprocessDataState = (dataState: State, dateFields: string[]): State => {
  let ds = { ...dataState };
  if (ds.filter) {
    const filters = ds.filter.filters.map((filter) => {
      const f = { ...filter } as FilterDescriptor;
      f.operator = nameToOperator(f.operator as string); // Deserialize name to its function
      if (dateFields.includes(f.field as string)) {
        f.value = new Date(f.value);
      }
      return f;
    });
    ds = { ...ds, filter: { ...ds.filter, filters: filters } };
  }
  return ds;
};

export const cleanDataState = (dataState: State) => {
  let ds = { ...dataState };
  if (ds.filter) {
    const filters = ds.filter.filters.map((filter) => {
      const f = { ...filter } as FilterDescriptor;
      if (typeof f.operator == 'function') {
        const { operator, ...rest } = f;
        return { ...rest, operator: operatorToName(f.operator) }; // Serialize function to its name
      }
      if (f.value instanceof Date) {
        const { value, ...rest } = f;
        return {
          ...rest,
          value: value.toISOString(), // Serialize date
        };
      } else {
        return f;
      }
    });
    // @ts-ignore
    ds = { ...ds, filter: { ...ds.filter, filters } };
  }
  return ds;
};

const getDataState = (tablesettings: TableSettings, dataStateToKeep?: State) => {
  return { ...getInitialDataState(), ...dataStateToKeep, ...tablesettings.gridSettings.dataState };
};

export const serializeSettings = (gridSettings: gridSettingsProps): gridSettingsProps => {
  const { filter, sort, take, skip } = gridSettings.dataState; // Extract the fields from dataState that we want to store to DB
  return { ...gridSettings, dataState: { filter, sort, take } };
};

export const unserializeSettings = (tableSettings: TableSettings, dataStateToKeep?: State): TableSettings => {
  const dataState = getDataState(tableSettings, dataStateToKeep);
  return { ...tableSettings, gridSettings: { ...tableSettings.gridSettings, dataState } };
};
